import { Component } from '@angular/core';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent {
  plans:any[]=[];

  dynamicPlans:any[]=[];

  constructor(public webApi: WebapiService, private toastrService: ToastrService) {
    this.getAllPlans()
  }

  getPlanPrice(type,codes,period){
    if(this.dynamicPlans[type] && codes[period]){
      const result = this.dynamicPlans[type].filter(item => item.code==codes[period]);
      if(result && result.length){
        return result[0].price
      }
    }
  }

  getAllPlans(){
    this.webApi.setLoader(true);
    this.webApi.frontendallplans().subscribe((data:any)=>{
      if(data.success==1){
        this.dynamicPlans = JSON.parse(data.plans)
        this.plans = data.frontendplans
      }
      this.webApi.setLoader(false);
    },error=>{
      this.webApi.setLoader(false);
      this.toastrService.error("unable to handle response");
    })
  }


  changeValue(plandetail,oldvalue){
    if(oldvalue=="month"){
      plandetail.type="year"
    }else{
      plandetail.type="month"
    }
  }
}
